import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import nextId from 'react-id-generator';
import { RESET_TOASTS, REMOVE_TOAST, CLEAR_TOASTS, ADD_TOAST } from './constants.js';

var toastsReducer = function toastsReducer(state, action) {
  switch (action.type) {
    case ADD_TOAST:
      var payload = action.payload;
      var id = payload.id;
      if (id && state.toasts.find(function (toast) {
        return toast.id === id;
      })) return state;
      return _objectSpread(_objectSpread({}, state), {}, {
        toasts: [].concat(_toConsumableArray(state.toasts), [_objectSpread(_objectSpread({}, action.payload), {}, {
          id: id || nextId("toast-")
        })])
      });

    case CLEAR_TOASTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        toasts: []
      });

    case REMOVE_TOAST:
      return _objectSpread(_objectSpread({}, state), {}, {
        toasts: state.toasts.filter(function (toast) {
          return action.payload !== toast.id;
        })
      });

    case RESET_TOASTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        toasts: state.toasts.filter(function (toast) {
          return toast.permanent === true;
        })
      });

    default:
      return state;
  }
};

export { toastsReducer as default };
